export enum BudgetCounterProposalSubStatusEnum {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export const BudgetCounterProposalSubStatusLabelMap: Record<
  BudgetCounterProposalSubStatusEnum,
  string
> = {
  [BudgetCounterProposalSubStatusEnum.ACCEPTED]: 'Aceito',
  [BudgetCounterProposalSubStatusEnum.REJECTED]: 'Recusado',
};

export const getBudgetCounterProposalSubStatusLabel = (
  subStatus: BudgetCounterProposalSubStatusEnum | string,
): string => {
  if (subStatus in BudgetCounterProposalSubStatusLabelMap) {
    return BudgetCounterProposalSubStatusLabelMap[subStatus as BudgetCounterProposalSubStatusEnum];
  }
  return subStatus;
};

